var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"SkeletonBox z-10 mt-4 w-full overflow-hidden rounded-lg",staticStyle:{"height":"1000px"}})])}]

export { render, staticRenderFns }